var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

        var initializeBlock = function ($block) {
            if (!$('body').hasClass('wp-admin')) {
                const listWorkers   = $('.row-workers');
                const arrayWorkers  = [];
                let arrayTemp       = [];
                const filter        = 'alpha';

                let all = false;

                $('.worker-box').each(function(){
                    const image = $(this).data('image');
                    const name  = $(this).data('name');
                    const department  = $(this).data('department');
                    const coffee  = $(this).data('coffee');
                    const screen  = $(this).data('screen-time');
                    const linkedin  = $(this).data('linkedin');
                    const xing  = $(this).data('xing');
                    const big  = $(this).data('big-image-text');
                    const small  = $(this).data('small-image-text');

                    arrayWorkers.push({
                        'image': image,
                        'name': name,
                        'department': department,
                        'coffee': coffee,
                        'screen': screen,
                        'linkedin': linkedin,
                        'xing': xing,
                        'big': big,
                        'small': small
                    });
                });

                function createWorkers(array, filterType) {
                    // Clear Items
                    listWorkers.empty();


                    // Create Items
                    for (let a=0; a<array.length; a++){
                        const linkedIn  = array[a]['linkedin'];
                        const xing      = array[a]['xing'];

                        let linkedInLink    = '';
                        let xingLink        = '';

                        if (linkedIn.length > 0) {
                            linkedInLink = '<a href="' + linkedIn + '" target="_blank" class="worker-box__social--linkedin"></a>';
                        }
                        if (xing.length > 0) {
                            xingLink = '<a href="' + xing + '" target="_blank" class="worker-box__social--xing"></a>';
                        }

                        let hidden = '';
                        if (filterType === 'coffee') {
                            if (array[a]['coffee'].length < 0 || array[a]['coffee'] <=0 ) {
                                hidden = 'hidden';
                            }
                        }
                        if (filterType === 'screen') {
                            if (array[a]['screen'].length < 0 || array[a]['screen'] <=0 ) {
                                hidden = 'hidden';
                            }
                        }

                        let backgroundClass = "";
                        let imageFile = "";
                        let bigText = "";
                        let smallText = "";
                        let cameraIcon = "";
                        if (array[a][`image`] == "") {
                            backgroundClass = "green-background";
                            bigText = '<strong>' + array[a][`big`] + '</strong>';
                            smallText = '<p>' + array[a][`small`] + '</p>';
                            cameraIcon = '<img src="' + domainTemplate + '/src/images/icon-camera.svg">';
                        } else {
                            imageFile = '<img width="333" height="500" class="worker-box__image" src="' + array[a][`image`] + '">';
                        }

                        listWorkers.append('<div class="col-6 col-xxxl-3 col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-worker ' + hidden + '">' +
                            '<div class="worker-box">' +
                            '<div class="worker-box__image-wrapper '+ backgroundClass +'">' +
                            imageFile + '<div class="worker-box__image-wrapper-placeholder">' + bigText + smallText + cameraIcon + '</div>' +
                            '</div>' +
                            '<div class="worker-box__content">' +
                            '<h3 class="worker-box__name">' + array[a][`name`] + '</h3><p class="worker-box__department">' + array[a][`department`] + '</p>' +
                            '<div class="worker-box__social">' + linkedInLink + xingLink +
                            '</div>' +
                            '</div>' +
                            '</div>' +
                            '</div>'
                        );
                    }

                    if ($(window).width() < 768 && !all) {
                        const total = $('.row-workers .col-worker').length;
                        if (total > 10) {
                            $('.row-workers .col-worker').addClass('is-hidden');

                            for (var a=0; a<10; a++) {
                                $('.row-workers .col-worker').eq(a).removeClass('is-hidden');
                            }
                        }
                    }
                }
                function filterItems(type){
                    // Clear Temp Array
                    arrayTemp = [];
                    for (let a=0; a<arrayWorkers.length; a++){
                        arrayTemp[a] = arrayWorkers[a];
                    }

                    if (type === 'name'){
                        arrayTemp.sort(function(a,b){
                            if(a.name > b.name){ return 1}
                            if(a.name < b.name){ return -1}
                            return 0;
                        });
                    } else if (type === 'department'){
                        arrayTemp.sort(function(a,b){
                            if(a.department > b.department){ return 1}
                            if(a.department < b.department){ return -1}
                            return 0;
                        });
                    } else if (type === 'coffee'){
                        arrayTemp.sort(function(a,b){
                            if(a.coffee > b.coffee){ return -1}
                            if(a.coffee < b.coffee){ return 1}
                            return 0;
                        });
                    } else if (type === 'screen'){
                        arrayTemp.sort(function(a,b){
                            if(a.screen > b.screen){ return -1}
                            if(a.screen < b.screen){ return 1}
                            return 0;
                        });
                    }

                    createWorkers(arrayTemp, type);
                }
                createWorkers(arrayWorkers, filter);

                const buttonFilter = $('.block-our-team-list__filters .fz-button-rounded');
                buttonFilter.on('click', function(e){
                    e.preventDefault();
                    if ($(this).hasClass('is-active')) {
                        buttonFilter.removeClass('is-active');
                        filterItems('alpha');
                    } else {
                        buttonFilter.removeClass('is-active');
                        $(this).addClass('is-active');
                        filterItems($(this).data('filter'));
                    }
                });
                buttonFilter.eq(0).click();

                // Button more
                const buttonMore = $('.block-our-team-list__buttons-wrapper button');
                if ($('html').is(':lang(de-DE)')) {
                    buttonMore.html('Mehr laden');
                }

                buttonMore.on('click', function(e){
                    e.preventDefault();

                    $('.worker-box').addClass('is-visible');
                    $(this).addClass('is-hidden');

                    $('.row-workers .col-worker').removeClass('is-hidden');

                    all = true;
                });
            }
    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=our-team-list', initializeBlock);
    }
});
